import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import PrivacyDescription from "../../Components/PrivacyDescription/PrivacyDescription";
import Footer from "../../Components/Common/Footer";

class PrivacyPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <PrivacyDescription />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default PrivacyPage;
